import React from 'react';
import { ApplicantOptionsDTO } from '../../../api/useRequiredDocsQuery';
import { Box } from '../../../../../CommonComponents/OPL/Box/Box';
import { Text } from '../../../../../CommonComponents/OPL/Text/Text';
import { Document } from '../Document/Document';

export interface Props {
  isSecondaryApplicant?: boolean;
  applicantOptions: ApplicantOptionsDTO;
}

export const ApplicantOptions = ({
  isSecondaryApplicant,
  applicantOptions: { firstName, lastName, acceptableDocumentsByCategory },
}: Props) => {
  return (
    <Box display="flex" flexDirection="column" my="32" css="gap: 16px">
      <Text fontWeight={600} fontSize="h5" color="neutral.600">
        {firstName} {lastName}
      </Text>

      {acceptableDocumentsByCategory.map(category => {
        return (
          <Document
            key={category.categoryDescription}
            isSecondaryApplicant={isSecondaryApplicant}
            category={category}
          />
        );
      })}
    </Box>
  );
};
